module.exports = __webpack_public_path__ + "img/LIGHT.d14c5976.svg";